import {RouteProps, SubRouteProps} from 'config/navigation';

import Orders from './orders';
import OrderDetails from './order-details';
import OrdersByStatus from './orders-by-status';
import {FaClipboardList} from 'react-icons/fa';
import ChangePaymentMethod from './change-payment-method';
import Cart from 'modules/cart/pages/cart';
import AddDocument from 'modules/cart/pages/add-document';
import PaymentMethods from 'modules/cart/pages/payment-methods';
import Address from 'modules/cart/pages/address';
import CompanyProducts from 'modules/products/pages/company-products';
import CartProdct from 'modules/products/pages/cart-product';
import CartAddresses from 'modules/cart/components/cart-addresses';
import Occurrences from './occurrences';
import CreateOccurrence from './create-occurrence';

const ordersPages: SubRouteProps[] = [
  {
    path: '',
    element: <OrdersByStatus />,
    permissions: ['orders.findAll'],
    hideDrawer: true,
    wrapper: false,
  },
  {
    path: ':id',
    element: <OrderDetails />,
    permissions: ['orders.findOne'],
    hideDrawer: true,
    wrapper: false,
    modals: [
      {
        path: 'payment-method',
        element: <ChangePaymentMethod />,
        title: 'Alterar forma de pagamento',
      },
      {
        path: 'occurrences',
        element: <Occurrences />,
        title: 'Ocorrências',
        size: 1000,
      },
      {
        path: 'occurrences/create',
        element: <CreateOccurrence />,
        title: 'Cadastrar ocorrências',
      },
    ],
  },
  {
    path: 'cart',
    element: <Cart />,
    permissions: ['orders.findOne'],
    modals: [
      {path: 'add-document', element: <AddDocument />},
      {
        path: ':companyId/payment-methods',
        element: <PaymentMethods />,
        centered: true,
      },
      {path: 'addresses/create', element: <Address />},
      {path: 'addresses', element: <CartAddresses />},
      {
        size: '70vw',
        path: ':companyId/products',
        element: <CompanyProducts />,
        centered: true,
      },
      {
        size: '60vw',
        path: ':companyId/products/:productId',
        element: <CartProdct />,
        centered: true,
        withCloseButton: false,
      },
    ],
    wrapper: false,
    hideDrawer: true,
  },
  {
    path: ':id/cart',
    element: <Cart />,
    permissions: ['orders.update'],
    modals: [
      {path: 'add-document', element: <AddDocument />},
      {
        path: ':companyId/payment-methods',
        element: <PaymentMethods />,
        centered: true,
      },
      {path: 'addresses/create', element: <Address />},
      {path: 'addresses', element: <CartAddresses />},
      {
        size: '70vw',
        path: ':companyId/products',
        element: <CompanyProducts />,
        centered: true,
      },
      {
        size: '60vw',
        path: ':companyId/products/:productId',
        element: <CartProdct />,
        centered: true,
        withCloseButton: false,
      },
    ],
    wrapper: false,
    hideDrawer: true,
  },
];

const manageOrdersPages: RouteProps = {
  name: 'Pedidos',
  path: 'manage-orders',
  permission: 'orders.findAll',
  icon: <FaClipboardList />,
  subRoutes: [
    {
      path: '',
      element: <Orders />,
      permissions: ['orders.findAll'],
    },
    {
      path: ':id',
      element: <OrderDetails />,
      permissions: ['orders.findOne'],
      hideDrawer: true,
      wrapper: false,
      modals: [
        {
          path: 'payment-method',
          element: <ChangePaymentMethod />,
          title: 'Alterar forma de pagamento',
        },
      ],
    },
  ],
};

export {ordersPages, manageOrdersPages};
